import User from '@/components/user/User'
import Users from '@/components/user/Users'
import Billing from '@/components/user/Billing'
import UserPage from '@/components/user/UserPage'
import UserProfile from '@/components/user/UserProfile'
import UserPreferences from '@/components/user/UserPreferences'
import Integrations from '@/components/user/Integrations'

export default [
  {
    path: 'profile',
    component: User,
    children: [
      {
        path: '',
        component: UserProfile,
        name: 'user-profile',
        meta: { title: 'Profile' }
      },
      {
        path: 'preferences',
        component: UserPreferences,
        name: 'user-preferences',
        meta: { title: 'User Preferences' }
      },
      {
        path: 'integrations',
        component: Integrations,
        name: 'integrations',
        meta: { title: 'Integrations', permission: 'integrations' }
      },
      {
        path: 'billing',
        component: Billing,
        name: 'billing',
        meta: { title: 'Billing', permission: 'billing' }
      }
    ]
  },
  {
    path: 'users',
    component: Users,
    name: 'users',
    meta: { title: 'Users' }
  },
  {
    path: 'users/:id',
    component: UserPage,
    name: 'user',
    meta: { title: 'User' }
  }
]
